import { ActionType } from 'deox';
import { call, put } from 'redux-saga/effects';

import { authLogoutAction } from '@/redux/actions';
import { authLogout, TAuthLogoutResponse } from '@/services/api';
import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* authLogoutSaga(action: ActionType<typeof authLogoutAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(authLogout, materials);
    const authLogoutResponse: TAuthLogoutResponse = response as TAuthLogoutResponse;
    yield put(authLogoutAction.success(authLogoutResponse));
    successCallback?.(authLogoutResponse);
  } catch (err) {
    yield put(authLogoutAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.logoutError');
  }
}
